<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-13 09:10:28
-->
<template>
    <div class="add-danwei">
        <div style="padding-left: 30px;">
          <el-table
            v-loading="listLoading"
            :data="tableData"
            size="mini"
            style="width: 100%; min-height: 300px"
        >
            <el-table-column prop="id" label="id" width="80" />
            <el-table-column prop="name" label="名称" width="80" />
            <el-table-column label="类型" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">户主</span>
                <span v-if="scope.row.type == 2">业主</span>
                <span v-if="scope.row.type == 3">租户</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="电话" width="100" />
            <el-table-column label="头像" minWidth="100">
                <template slot-scope="scope">
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="$adddom(scope.row.avatar)"
                        :preview-src-list="[$adddom(scope.row.avatar)]"
                    >
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column label="操作" minWidth="100">
              <template slot-scope="scope">
                  <div class="btns-wrap">
                    <el-button
                      type="danger"
                      @click="del(scope.row)"
                      style="
                                   background: rgb(255, 73, 73);
                                   border-color: rgb(255, 73, 73);
                                "
                    >删除</el-button
                    >
                  </div>
              </template>
            </el-table-column>
        </el-table>
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import fetch from "@/api/tianzheng/member";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            id: "",
            listLoading: false,
            tableData: {},
        };
    },
    components: {
        Pagination,
    },
    created() {},
    mounted() {},
    methods: {
        del(row){
          let that = this;
          this.listLoading = true;
          fetch.removeFamilyMember({id:row.id}).then((res) => {
            that.listLoading = false;
            that.initFun({id:this.id});
          });
        },
      initFun(obj) {
            let that = this;
            if (obj.id) {
                // 编辑
                this.id = obj.id;
                this.listLoading = true;
                fetch.familyMember({ id: this.id }).then((res) => {
                    that.listLoading = false;
                    that.tableData = res.result
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}
</style>
